import { ReactNode } from "react";

interface SpeakableContentProps {
  children: ReactNode;
  cssSelector?: string;
  pageUrl?: string;
  headline?: string;
}

/**
 * Wrapper component that adds SpeakableSpecification schema markup
 * for voice search optimization (Google Assistant, Alexa, etc.)
 */
export default function SpeakableContent({
  children,
  cssSelector = ".speakable-content",
  pageUrl,
  headline,
}: SpeakableContentProps) {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "speakable": {
      "@type": "SpeakableSpecification",
      "cssSelector": [cssSelector, "h1", ".direct-answer", ".quick-answer"],
    },
    ...(pageUrl && { "url": pageUrl }),
    ...(headline && { "name": headline }),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <div className="speakable-content">{children}</div>
    </>
  );
}
